import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { guestGuard } from '@core/guards/guest.guard';
import { verifyEmailGuard } from '@core/guards/verify-email.guard';
import { ForgotPasswordComponent } from './presentation/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './presentation/pages/reset-password/reset-password.component';
import { AuthWelcomeComponent } from './presentation/pages/auth-welcome/auth-welcome.component';
import { AppSideLoginComponent } from './presentation/pages/side-login/side-login.component';
import { AppSideRegisterComponent } from './presentation/pages/side-register/side-register.component';
import { VerifyEmailComponent } from './presentation/pages/verify-email/verify-email.component';
import { ChooseWorkspaceComponent } from './presentation/pages/choose-workspace/choose-workspace.component';

/** Rutas hijas bajo `/authentication` (eager: evita fallo de chunk lazy en logout). */
export const authenticationChildRoutes: Routes = [
  { path: '', pathMatch: 'full', component: AuthWelcomeComponent },
  { path: 'error', redirectTo: '/not-found', pathMatch: 'full' },
  { path: 'login', component: AppSideLoginComponent, canActivate: [guestGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'register', component: AppSideRegisterComponent, canActivate: [guestGuard] },
  {
    path: 'verify-email',
    component: VerifyEmailComponent,
    canActivate: [authGuard, verifyEmailGuard],
  },
  {
    path: 'choose-workspace',
    component: ChooseWorkspaceComponent,
    canActivate: [authGuard],
  },
];

/** @deprecated Usar {@link authenticationChildRoutes} en app.routes. */
export const AuthRoutes: Routes = [
  {
    path: '',
    children: authenticationChildRoutes,
  },
];
